import * as templateDocumentActions from "@rentiohq/shared-frontend/dist/redux/templateDocument/templateDocument.actions";
import * as templateDocumentSelectors from "@rentiohq/shared-frontend/dist/redux/templateDocument/templateDocument.selectors";
import * as templateDocumentUtils from "@rentiohq/shared-frontend/dist/redux/templateDocument/templateDocument.utils";
import {
  ETemplateDocumentStatus,
  IContract,
} from "@rentiohq/shared-frontend/dist/types/contract.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { IRootStore } from "redux/reducers";
import StatusDot, { EStatus } from "../StatusDot";
interface IProps {
  contract: IContract;
}

const StatusDotTemplateDocumentContract = (props: IProps) => {
  const dispatch = useDispatch();
  const { contract } = props;

  // Template documents
  const contractTemplateDocumentsFilter = {
    where: {
      contractId: contract.id,
      type: { like: "%contract%", options: "i" },
    },
  };

  const contractTemplateDocuments = useSelector((state: IRootStore) =>
    templateDocumentSelectors.paged.dataForPage(state, {
      id: templateDocumentUtils.getPagedId({
        filter: contractTemplateDocumentsFilter,
      }),
      page: 0,
    }),
  );

  const isFetchingContractTemplateDocuments = useSelector((state: IRootStore) =>
    templateDocumentSelectors.paged.isFetchingPage(state, {
      id: templateDocumentUtils.getPagedId({
        filter: contractTemplateDocumentsFilter,
      }),
      page: 0,
    }),
  );

  // Template documents
  React.useEffect(() => {
    if (isFetchingContractTemplateDocuments) {
      return;
    }

    dispatch(
      templateDocumentActions.getPaged.actions.start({
        page: 0,
        // limit: 100,
        filter: contractTemplateDocumentsFilter,
      }),
    );
  }, [contract.id]);

  // Helpers
  const getStatus = () => {
    if (contract.manuallyCompletedTemplateDocumentContract) {
      return EStatus.Success;
    }

    const templateDocument = contractTemplateDocuments?.[0];
    const { status = ETemplateDocumentStatus.New } = templateDocument || {};

    switch (status) {
      default:
      case ETemplateDocumentStatus.New:
      case ETemplateDocumentStatus.Failed:
        return EStatus.Error;

      case ETemplateDocumentStatus.Generating:
        return EStatus.Warning;

      case ETemplateDocumentStatus.Generated:
        return EStatus.Success;
    }
  };

  // Render
  const renderTooltipContent = () => {
    if (!contract) {
      return;
    }

    if (contract.manuallyCompletedTemplateDocumentContract) {
      return getLocalizedText(
        contract.manuallyCompletedTemplateDocumentContract,
      );
    }

    const templateDocument = contractTemplateDocuments?.[0];
    const { status = ETemplateDocumentStatus.New } = templateDocument || {};

    return getLocalizedText(`template_document.status.${status}`.toLowerCase());
  };

  return (
    <StatusDot status={getStatus()} tooltipContent={renderTooltipContent()} />
  );
};

// eslint-disable-next-line import/no-default-export
export default StatusDotTemplateDocumentContract;
